import React, {ReactElement} from 'react';
import {useEffect} from 'react';
import {useState} from 'react';
import closeIcon from '../../assets/images/cross-icon.svg';
import {makeid} from '../../core/utils/string.util';
import useWindowDimensions from '../../core/utils/window.utils';

export enum ModalAnimateDirection {
  BOTTOM_TO_TOP,
  RIGHT_TO_LEFT,
}

type ModalProps = {
  children?: React.ReactNode;
  backColor?: string;
  setbackopacity?: string;
  isVisible?: boolean;
  onClose?: () => void;
  animate?: boolean;
  animateDirection?: ModalAnimateDirection;
  className?: string;
  crossVisible?: boolean;
};

const MidScreenModal = ({
  children,
  onClose,
  isVisible,
  animate,
  animateDirection,
  className,
  crossVisible,
  backColor,
  setbackopacity,
}: ModalProps): ReactElement => {
  const [showModal, setShowModal] = useState(false);
  const {width} = useWindowDimensions();
  const [modalAnimateClasses, setModalAnimateClasses] = useState<string>('');

  const modalId = `msm_${makeid(6)}_${makeid(3)}`;

  useEffect(() => {
    //.log(width);
    if (animate && animateDirection) {
      if (isVisible) {
        setModalAnimateClasses(
          'animate__animated animate__zoomIn animate__faster',
        );
        setShowModal(true);
      } else {
        setModalAnimateClasses(
          'animate__animated animate__zoomOut animate__faster',
        );
        setTimeout(() => {
          setShowModal(false);
        }, 500);
      }
    } else {
      setShowModal(isVisible || false);
    }
  }, [isVisible]);
  if (crossVisible === undefined) {
    crossVisible = true;
  }
  if (backColor === undefined) {
    backColor = 'bg-white';
  }
  if (setbackopacity === undefined) {
    setbackopacity = 'bg-opacity-80';
  }
  return (
    <React.Fragment>
      {showModal && (
        <div className="fixed inset-0 z-20">
          <div className="flex items-center justify-center min-h-screen text-center ">
            <div className="fixed inset-0 trasition-opacity">
              <div
                className={`absolute inset-0 bg-black ${setbackopacity}`}></div>
            </div>
            <div
              className={`relative inline-block modal-wrapper w-80 h-auto rounded-3xl ${modalAnimateClasses} ${className} ${backColor}`}
              id={modalId}
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline">
              <div className="absolute -top-16 -right-4 cross-icon">
                {crossVisible === true ? (
                  <img src={closeIcon} onClick={onClose} />
                ) : (
                  ''
                )}
              </div>
              {children}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default MidScreenModal;
